import { useCallback, useEffect, useState } from 'react'
import _debounce from 'lodash/debounce'
import {
  BREAKPOINT_CHECKS,
  findOptionAndDeviceFromQuery,
  RESIZING_TIMER,
} from '../../../lib/Media'

const useMediaQuery = query => {
  const [isRendered, setIsRendered] = useState(false)

  const processDisplay = useCallback(() => {
    const { optionKey, deviceKey } = findOptionAndDeviceFromQuery(query)
    setIsRendered(BREAKPOINT_CHECKS[optionKey][deviceKey](window.innerWidth))
  }, [query])

  useEffect(() => {
    processDisplay()
    window.addEventListener('resize', _debounce(processDisplay, RESIZING_TIMER))

    return () => {
      window.removeEventListener(
        'resize',
        _debounce(processDisplay, RESIZING_TIMER)
      )
    }
  }, [processDisplay])

  return isRendered
}

export default useMediaQuery
